module.exports = __webpack_public_path__ + "static/media/Доклад за прилагане на пол. за възнагражденията_2019.eca88aaa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Доклад за прилагане на пол. за възнагражденията_2019.pdf
// module id = 113
// module chunks = 0